<template lang="pug">
.options
  .backdrop
  .content
    .close(@click="cancel") ×
    .form
      .field
        label(for="transfer-code")
          NewTranslation(path="transferCode.taxId.label")
        .field-input
          font-awesome-icon(icon="qrcode")
          input(v-model="taxId" placeholder="XXXXXXXX-XXXXXX-XXXX-X" required)
      .field
        label(for="transfer-code")
          NewTranslation(path="transferCode.code.label")
        .field-input
          font-awesome-icon(icon="fingerprint")
          input(v-model="code" type="number" placeholder="XXXXXX" required maxlength="6")
      div(v-if="validationErrors.length" class="field-error")
        div(v-for="error in validationErrors")
          span(v-for="constraint in error.constraints") {{ constraint }}
      Button(color="green" @click.native="success" path="setPasswordDialog.continue.button").button
        font-awesome-icon(icon="chevron-right" slot="icon" style="padding-left: 2px")
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import { mapActions } from 'vuex';
import i18next from 'i18next';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  data: () => {
    return {
      taxId: '',
      code: '',
      validationErrors: [],
    };
  },
  mounted() {
    this.$trackEvent('profile', 'transfer-taxcard', 'entered');
    this.taxId = this.overlaydata.taxId;
  },
  methods: {
    cancel() {
      this.$store.commit('openOverlay', '');
    },
    success() {
      const { taxId, code } = this;
      this.$trackEvent('profile', 'transfer-taxcard', 'submit', taxId + ' : ' + code);
      this.transferTaxcard({ taxId, code })
        .then(() => {
          this.$trackEvent('profile', 'transfer-taxcard', 'success');
          this.$store.commit('openOverlay', {
            overlayName: 'Info',
            overlayData: {
              title: i18next.t('splash.transferTaxcard.dialog.success.title'),
              message: i18next.t('splash.transferTaxcard.dialog.success.body'),
            },
          });
        })
        .catch(error => {
          this.$trackEvent('profile', 'transfer-taxcard', 'error');
          this.validationErrors = error.response.data.errors;
        });
    },
    ...mapActions(['transferTaxcard']),
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 3000
.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6
.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  width: calc(100% - 40px)
  max-height: 100vh
  overflow: auto
.form
  margin-top: 10px
</style>
